import { render, staticRenderFns } from "./TeacherInvitationDialog.vue?vue&type=template&id=38c5313e&scoped=true&"
import script from "./TeacherInvitationDialog.vue?vue&type=script&lang=js&"
export * from "./TeacherInvitationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c5313e",
  null
  
)

export default component.exports